import { gossipTestimonials } from "@/mocks/testimonials";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="VOICES"
          title="长期读者怎么说"
          desc="这些话来自经常使用事件库的读者，也是我们继续整理下去的理由。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {gossipTestimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 70}>
              <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <i className="ri-double-quotes-l text-2xl text-primary-300" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.quote}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-background-200">
                    <img
                      src={item.avatar}
                      alt={`${item.name}的头像插画`}
                      title={`${item.name} - 网报吃瓜读者口碑`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}

          <Reveal delay={350}>
            <div className="flex h-full flex-col justify-between rounded-lg bg-secondary-100 p-5">
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-500 text-foreground-950">
                  <i className="ri-mail-send-line text-xl" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">想第一时间收到新整理？</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  留下邮箱，我们每周把刚整理完的事件串汇总发一次，不推送无关内容，随时可以退订。
                </p>
              </div>
              <a
                href="#subscribe"
                className="mt-5 inline-flex items-center gap-2 self-start rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap"
              >
                去订阅
                <i className="ri-arrow-down-line" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}